<div class="modal-container">
    <div class="pvat-cabecalho">
        <h2 mat-dialog-title class="dialog-title">
            <mat-icon>label</mat-icon>
            <span>Alterar tags</span>
        </h2>
        <button mat-icon-button (click)="fechar()" [disabled]="isLoading">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="dialog-content">
        <p class="question-label">O que deseja fazer com os {{ data.idsVenda.length }} documento(s) selecionado(s)?</p>
        <mat-form-field appearance="outline" class="pvat-campo">
            <mat-label>Ação</mat-label>
            <mat-select [(ngModel)]="acao" (ngModelChange)="onAcaoChange()">
                <mat-option [value]="acaoEnum.Incluir">Incluir tags</mat-option>
                <mat-option [value]="acaoEnum.Remover">Remover tags</mat-option>
                <mat-option [value]="acaoEnum.Substituir">Substituir tags</mat-option>
            </mat-select>
        </mat-form-field>
        <p class="help-text">{{ helpText }}</p>

        <div class="tags-header">
            <span class="tags-label">Selecione as tags</span>
            @if (tagsSelecionadas.size > 0) {
                <span class="status-badge badge-vermelho">{{ contadorText }}</span>
            }
        </div>

        <mat-form-field appearance="outline" class="pvat-campo">
            <mat-label>Buscar tags...</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput [(ngModel)]="searchText" (ngModelChange)="filtrarTags()" />
        </mat-form-field>

        <div class="tag-list">
            @for (tag of tagsFiltradas; track tag.idTagVenda) {
                <div class="tag-item" (click)="toggleTag(tag.idTagVenda)">
                    <mat-checkbox
                        [checked]="isTagSelecionada(tag.idTagVenda)"
                        (click)="$event.stopPropagation()"
                        (change)="toggleTag(tag.idTagVenda)">
                        <span class="tag-label">
                            <span class="tag-cor" [style.background-color]="tag.cor"></span>
                            {{ tag.descricao }}
                        </span>
                    </mat-checkbox>
                </div>
            }

            @if (tagsFiltradas.length === 0) {
                <p class="empty-tags">Nenhuma tag encontrada.</p>
            }
        </div>
    </div>

    <div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
        <button mat-stroked-button class="btn-secondary" (click)="fechar()" [disabled]="isLoading">Cancelar</button>
        <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isLoading"
            [attr.aria-label]="isLoading ? 'Aplicando' : 'Aplicar'" [disabled]="!podeAplicar" (click)="salvar()">
            Aplicar
            @if (isLoading) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
    </div>
</div>
